import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import { Form } from 'components';
import { plural } from 'lib/utils';
import './style.scss';

class AddLedgerPayment extends Component {
  static propTypes = {
    data: PropTypes.object
  };

  static defaultProps = {
    data: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      id: null,
      parent_payment: null,
      kid_ids: [],
      isSaving: false,
      isEditing: !!props.data.transaction
    };

    if (props.data.transaction) {
      const { transactable } = props.data.transaction;
      this.state.id = transactable.id;
      this.state.parent_payment = pick(transactable, ['amount', 'description', 'notes']);
      this.state.kid_ids = [...transactable.kid_ids];
    }

    if (props.data.students) {
      this.state.kid_ids = (props.data.students || []).map(student => student.id);
    }
  }

  @bind
  async handleSelectStudents() {
    const { kid_ids } = this.state;

    try {
      const result = await Actions.showModal('SelectLedgerStudents', { kid_ids });
      if (result) {
        this.setState({ kid_ids: result });
      }
    } catch (e) {
      // do nothing
    }
  }

  @bind
  async handleSubmit(parent_payment) {
    const { kid_ids, id, isEditing } = this.state;
    const {
      data: { ledger },
      onClose
    } = this.props;

    try {
      this.setState({ isSaving: true, kid_ids });
      if (isEditing) {
        await req.updateLedgerCredit({
          id,
          parent_payment: {
            ...parent_payment,
            amount: +parent_payment.amount,
            kid_ids
          }
        });
        Actions.showFlash('Updated payment successfully');
      } else {
        await req.addLedgerCredit({
          ledger_id: ledger.id,
          parent_payment: {
            ...parent_payment,
            amount: +parent_payment.amount,
            kid_ids
          }
        });
        Actions.showFlash('Received payment successfully');
      }
      this.setState({ isSaving: false });

      onClose(true);
    } catch (e) {
      Actions.reportError('Something went wrong', e);
      this.setState({ isSaving: false });
    }
  }

  render() {
    const {
      data: { ledger }
    } = this.props;
    const { parent_payment, kid_ids, isSaving, isEditing } = this.state;
    const title = isEditing ? 'Edit Payment' : 'Receive Payment';
    const defaultValues = parent_payment || {};

    return (
      <Form
        className="modal__wrapper add-ledger-payment"
        onSubmit={this.handleSubmit}
        validateOn="submit"
        isLoading={isSaving}
      >
        <div className="modal__header modal__header--bordered">
          <div className="modal__header-title">{title}</div>
          <div className="modal__header-subtitle">
            For <b>{ledger.name}</b>
          </div>
        </div>

        <div className="modal__container">
          <div className="form__row form__row--justified">
            <Form.Input
              label="Amount"
              placeholder="Enter Amount eg. $100"
              name="amount"
              type="amount"
              data-cy="amount"
              defaultValue={defaultValues.amount}
              amount
              required
            />
          </div>

          <div className="form__row">
            <Form.Textarea
              label="Description"
              placeholder="Add description"
              name="description"
              data-cy="description"
              defaultValue={defaultValues.description}
              required
            />
          </div>

          <a data-cy="assign-students" className="add-ledger-payment__kids" onClick={this.handleSelectStudents}>
            {!kid_ids.length ? 'Optionally Assign Students' : `${plural(kid_ids.length, 'Student')} Assigned`}
          </a>

          <Form.Input
            placeholder="Optional internal note that won't show in reports"
            name="notes"
            className="form-input--highlight"
            defaultValue={defaultValues.notes}
          />

          <div className="form__row form__row--actions">
            <Form.Submit label="Save" data-cy="submit" />
          </div>
        </div>
      </Form>
    );
  }
}

export default AddLedgerPayment;
